'use client';

import { useSearchParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';

import Main from 'molecules/Main';

import RenderBuilderContent from 'components/Builder/BuilderComponent';
import HealthCareEntries from 'components/HealthcareEntries';

import { getDraftPost } from 'utils/builder/builderDataFunctions';

import type { BuilderElement } from '@builder.io/react';
import type { FC } from 'react';

interface DraftContentBuilder {
  model: string;
}

const GenerateDraftContent: FC<DraftContentBuilder> = ({ model }) => {
  const [content, setContent] = useState<any>(null);
  const searchParams = useSearchParams();
  const postId = searchParams.get(`builder.overrides.${model}`) || '';

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const draftContent = await getDraftPost(model, postId);

        return setContent(draftContent);
      } catch (error) {
        console.error('Error fetching draft content:', error);
      }
    };

    fetchContent();
  }, []);

  if (!content) {
    return null;
  }
  const components = content?.data?.blocks as BuilderElement[];
  const props = { components, content, model };

  const generateContent = () => {
    switch (model) {
      case 'page':
        return <RenderBuilderContent {...props} />;
      case 'template-article':
      case 'template-claims-lesson':
      case 'template-course':
      case 'template-podcast':
      case 'template-risk-assessment':
      case 'template-risk-report':
      case 'template-toolkit':
      case 'template-video':
        return <HealthCareEntries {...props} />;
      default:
        return null;
    }
  };

  return <Main>{generateContent()}</Main>;
};

export default GenerateDraftContent;
